import config from 'config/Config';
import BaseApi from './BaseApi';
import { UserSummary } from 'types/store/normalized';

export class UserSummariesApi extends BaseApi<UserSummary> {
  constructor() {
    super(`${config.get('backendURL')}v2/user-summaries/query`);
  }
}
